import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const InterviewList = (teamData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_INTERVIEW_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/interview/list-interview`,
        teamData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_INTERVIEW_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_INTERVIEW_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_INTERVIEW_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const UpdateInterview = (interviewData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_INTERVIEW_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/interview/update-interview/${interviewData.id}`,
        interviewData,
        config
      );

      if (data.statusCode === 200) {
        toast.success(data.message || "Interview updated successfully!");
        dispatch({ type: "UPDATE_INTERVIEW_SUCCESS", payload: data.data });
        // dispatch(InterviewList({ agent_id: interviewData.agent_id, page: 1, limit: 10, is_deleted: false }));
      } else {
        toast.error(data.message || "Failed to update interview");
        dispatch({ type: "UPDATE_INTERVIEW_FAILED", payload: data });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong!");
      dispatch({
        type: "UPDATE_INTERVIEW_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const AgentList = (teamData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_AGENT_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/agent/list`,
        teamData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_AGENT_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_AGENT_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_AGENT_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const SendAgentNotification = (notificationData) => {
  return async (dispatch) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/notifications/send-agent-notification`,
        notificationData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "SEND_AGENT_NOTIFICATION_SUCCESS", payload: data });
      } else {
        toast.error(data.message || "Failed to send notification");
        dispatch({ type: "SEND_AGENT_NOTIFICATION_FAILED", payload: data });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong!");
      dispatch({
        type: "SEND_AGENT_NOTIFICATION_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const AgentListView = (teamData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_AGENT_LIST_VIEW_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/agent/profile/${teamData}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_AGENT_LIST_VIEW_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_AGENT_LIST_VIEW_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "GET_AGENT_LIST_VIEW_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const UpdateStaffDocuments = (staffId, documents) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_STAFF_DOCUMENTS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/agent/update-documents/${staffId}`,
        { documents },
        config
      );

      if (data.statusCode === 200) {
        toast.success("Documents updated successfully!");
        dispatch({ type: "UPDATE_STAFF_DOCUMENTS_SUCCESS", payload: data });
      } else {
        toast.error(data.message || "Update failed");
        dispatch({ type: "UPDATE_STAFF_DOCUMENTS_FAILED", payload: data });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      dispatch({
        type: "UPDATE_STAFF_DOCUMENTS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const UpdateAgentCategory = (agentId, categoryData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_AGENT_CATEGORY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/agent/update-category/${agentId}`,
        categoryData,
        config
      );

      if (data.statusCode === 200) {
        toast.success(data.message || "Agent category updated successfully!");
        dispatch({ type: "UPDATE_AGENT_CATEGORY_SUCCESS", payload: data });
        dispatch(AgentListView(agentId));
      } else {
        toast.error(data.message || "Failed to update category");
        dispatch({ type: "UPDATE_AGENT_CATEGORY_FAILED", payload: data });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong!");
      dispatch({
        type: "UPDATE_AGENT_CATEGORY_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


// export const addTeamMember = (memberData) => {
//   return async (dispatch) => {
//     dispatch({ type: "START_LOADING" });
//     try {
//       dispatch({ type: "ADD_MEMBER_REQUEST" });
//       console.log("BASE_URL:", process.env.REACT_APP_API_BASE_URL);

//       const config = {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       };

//       const { data } = await axios.post(
//         `${BASE_URL}/staff/create`,
//         memberData,
//         config
//       );
//       if (data.statusCode === 200) {
//         dispatch({ type: "ADD_MEMBER_SUCCESS", payload: data });
//         toast.success("Added Successfully!");
//         return data;
//       } else {
//         dispatch({ type: "ADD_MEMBER_FAILED", payload: data });
//         toast.error("Something went wrong!!");
//       }
//     } catch (error) {
//       dispatch({ type: "ADD_MEMBER_FAILED", payload: error.message });
//       toast.error("Something went wrong!!");
//     } finally {
//       dispatch({ type: "STOP_LOADING" });
//     }
//   };
// };

// export const viewTeamMembersListNoPagination = (teamData) => {
//   return async (dispatch) => {
//     dispatch({ type: "START_LOADING" });
//     try {
//       dispatch({ type: "GET_TEAM_MEMBERS_LIST_REQUEST" });

//       const config = {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       };
//       const { data } = await axios.post(
//         `${BASE_URL}/staff/alllist`,
//         teamData,
//         config
//       );
//       if (data.statusCode === 200) {
//         dispatch({ type: "GET_TEAM_MEMBERS_LIST_SUCCESS", payload: data });
//       } else {
//         dispatch({ type: "GET_TEAM_MEMBERS_LIST_FAILED", payload: data });
//       }
//     } catch (error) {
//       dispatch({
//         type: "GET_TEAM_MEMBERS_LIST_FAILED",
//         payload: error?.response?.data?.message,
//       });
//     } finally {
//       dispatch({ type: "STOP_LOADING" });
//     }
//   };
// };

// export const blockUnblockMember = (blockUnblockData) => {
//   return async (dispatch) => {
//     dispatch({ type: "START_LOADING" });
//     try {
//       dispatch({ type: "BLOCK_UNBLOCK_MEMBER_REQUEST" });

//       const config = {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       };

//       const { data } = await axios.post(
//         `${BASE_URL}/staff/block-unblock`,
//         blockUnblockData,
//         config
//       );

//       if (data.statusCode === 200) {
//         dispatch({ type: "BLOCK_UNBLOCK_MEMBER_SUCCESS", payload: data });
//         toast.success("Operation successful!");
//         return data;
//       } else {
//         dispatch({ type: "BLOCK_UNBLOCK_MEMBER_FAILED", payload: data });
//         toast.error("Something went wrong!!");
//       }
//     } catch (error) {
//       dispatch({ type: "BLOCK_UNBLOCK_MEMBER_FAILED", payload: error.message });
//       toast.error("Something went wrong!!");
//     } finally {
//       dispatch({ type: "STOP_LOADING" });
//     }
//   };
// };


export const UpdateAgentStatus = (agentData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_PROFILE_STATUS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/agent/update-account-status`,
        agentData,
        config
      );
      if (data.statusCode === 200) {
        toast.success("Profile Status  updated successfully!");
        dispatch({ type: "UPDATE_PROFILE_STATUS_SUCCESS", payload: data });
      } else {
        toast.error(data.message || "Update failed");
        dispatch({ type: "UPDATE_PROFILE_STATUS_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      dispatch({
        type: "UPDATE_PROFILE_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};



export const TimeslotList = (payload) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_TIMESLOT_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/time-slot/list`,
        { page: payload.page, limit: payload.limit, search: payload.search },
        config
      );

      if (data.statusCode === 200) {
        dispatch({
          type: "GET_TIMESLOT_LIST_SUCCESS",
          payload: { data: data.data, count: data.total },
        });
      } else {
        dispatch({ type: "GET_TIMESLOT_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_TIMESLOT_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const AddTimeslots = (timeSlots) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_TIMESLOT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/time-slot/add`,
        { time_slots: timeSlots },
        config
      );

      if (data.statusCode === 200) {
        toast.success("Time slots added successfully");
        dispatch({ type: "ADD_TIMESLOT_SUCCESS", payload: data });
      } else {
        toast.error(data.message || "Failed to add time slots");
        dispatch({ type: "ADD_TIMESLOT_FAILED", payload: data });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      dispatch({
        type: "ADD_TIMESLOT_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const DisableTimeslot = (id, date, reason = null) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "DISABLE_TIMESLOT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/time-slot/disable`,
        { id, date, reason },
        config
      );

      if (data.statusCode === 200) {
        toast.success("Slot disabled for the given date");
        dispatch({ type: "DISABLE_TIMESLOT_SUCCESS", payload: data });
      } else {
        toast.error(data.message || "Failed to disable slot");
        dispatch({ type: "DISABLE_TIMESLOT_FAILED", payload: data });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      dispatch({
        type: "DISABLE_TIMESLOT_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const UpdateTimeslot = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "UPDATE_TIMESLOT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/time-slot/update`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        toast.success("Time slot updated successfully");
        dispatch({ type: "UPDATE_TIMESLOT_SUCCESS", payload: data });
      } else {
        toast.error(data.message || "Failed to update time slot");
        dispatch({ type: "UPDATE_TIMESLOT_FAILED", payload: data });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      dispatch({
        type: "UPDATE_TIMESLOT_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const DisableWholeDay = (date, reason = null) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "DISABLE_WHOLE_DAY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/time-slot/disable-whole-day`,
        { date, reason },
        config
      );

      if (data.statusCode === 200) {
        // toast.success("Whole day disabled successfully");
        dispatch({ type: "DISABLE_WHOLE_DAY_SUCCESS", payload: data });
      } else {
        toast.error(data.message || "Failed to disable whole day");
        dispatch({ type: "DISABLE_WHOLE_DAY_FAILED", payload: data });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      dispatch({
        type: "DISABLE_WHOLE_DAY_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const EnableWholeDay = (date) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ENABLE_WHOLE_DAY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/time-slot/enable-whole-day`,
        { date },
        config
      );

      if (data.statusCode === 200) {
        toast.success("Whole day enabled successfully");
        dispatch({ type: "ENABLE_WHOLE_DAY_SUCCESS", payload: data });
      } else {
        toast.error(data.message || "Failed to enable whole day");
        dispatch({ type: "ENABLE_WHOLE_DAY_FAILED", payload: data });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      dispatch({
        type: "ENABLE_WHOLE_DAY_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const ApproveRejectStaffUpdateRequest = (payload) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "APPROVE_REJECT_STAFF_UPDATE_REQUEST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/staff/approve-reject`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        toast.success(
          payload.status === "approved"
            ? "Request approved successfully!"
            : "Request rejected successfully!"
        );
        dispatch({ type: "APPROVE_REJECT_STAFF_UPDATE_REQUEST_SUCCESS", payload: data });
        return data;
      } else {
        toast.error(data.message || "Failed to update request");
        dispatch({ type: "APPROVE_REJECT_STAFF_UPDATE_REQUEST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong!");
      dispatch({
        type: "APPROVE_REJECT_STAFF_UPDATE_REQUEST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const ListStaffUpdateRequests = (payload) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "LIST_STAFF_UPDATE_REQUEST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/staff/profile-request-list`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_STAFF_UPDATE_REQUEST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "LIST_STAFF_UPDATE_REQUEST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "LIST_STAFF_UPDATE_REQUEST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const ListAgentRoleUpdate = (payload) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "AGENT_ROLE_UPDATE_REQUEST" });

      const config = { headers: { "Content-Type": "application/json" } };

      const { data } = await axios.post(
        `${BASE_URL}/agent/update-role`,
        payload,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "AGENT_ROLE_UPDATE_SUCCESS", payload: data });
        toast.success(data.message || "Role updated successfully");
        return data;
      } else {
        dispatch({ type: "AGENT_ROLE_UPDATE_FAILED", payload: data });
        toast.error(data.message || "Failed to update role");
        return data;
      }
    } catch (error) {
      dispatch({
        type: "AGENT_ROLE_UPDATE_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};